var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Landmark-st0{fill:currentColor;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Landmark-st0",
    d: "M2.3,8.2H1.7v-1h0.4H12h10.3v1h-0.5h-4.5h-3H9.8h-3H2.3z M13.2,4.2c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1 s0.5,1.1,1.1,1.1S13.2,4.9,13.2,4.2z M3.7,18.9l-1,1.5h3.5l-1-1.5c0,0,0-0.1,0-0.1v-8.4c0,0,0-0.1,0-0.1l1-1.6H2.8l1,1.6 c0,0,0,0.1,0,0.1v8.3C3.8,18.8,3.8,18.9,3.7,18.9z M12,6.6H2.9L12,0.5l9.1,6.2H12L12,6.6z M14.3,4.2c0,0.2,0.1,0.3,0.3,0.3h1.7 c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3h-1.7C14.4,4,14.3,4.1,14.3,4.2z M9.8,4.2C9.8,4.1,9.6,4,9.5,4H7.8 C7.6,4,7.5,4.1,7.5,4.2c0,0.2,0.1,0.3,0.3,0.3h1.7C9.6,4.5,9.8,4.4,9.8,4.2z M12,5.9c0.9,0,1.7-0.8,1.7-1.7S13,2.6,12,2.6 c-0.9,0-1.7,0.8-1.7,1.7S11.1,5.9,12,5.9z M20.3,10.3l1-1.6h-3.5l1,1.6c0,0,0,0.1,0,0.1v8.3c0,0,0,0.1,0,0.1l-1,1.6h3.5l-1-1.6 c0,0,0-0.1,0-0.1v-8.3C20.3,10.4,20.3,10.3,20.3,10.3z M22.4,21h-0.6h-4.5h-3H9.8h-3H2.3H1.7v1h20.7C22.4,22,22.4,21,22.4,21z  M22.7,22.5H1.4H0v1h24.1v-1H22.7z M12.8,18.9c0,0,0-0.1,0-0.1v-8.4c0,0,0-0.1,0-0.1l1-1.6h-3.5l1,1.6c0,0,0,0.1,0,0.1v8.3 c0,0,0,0.1,0,0.1l-1,1.6h3.5L12.8,18.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandmark);
export default __webpack_public_path__ + "static/media/Landmark.60a0ce2e952ee0fe6aed1dd9a2f85a44.svg";
export { ForwardRef as ReactComponent };